(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-specfication"] && !window.DesignMode) return;
  try {
    
        const accordions = Array.from(document.querySelectorAll('.accordion'))
        accordions.forEach(accordion => {
          const accordionHeader = accordion.querySelector('.accordion__header')
          accordionHeader.addEventListener('click', event => {
            accordions.forEach(accordion => {
              accordion.classList.remove('open')
            })
            accordion.classList.toggle('open')
          })
        })
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-accordion-with-text"] && !window.DesignMode) return;
  try {
    
      const accordions = Array.from(document.querySelectorAll('.accordion'))
      accordions.forEach(accordion => {
        const accordionHeader = accordion.querySelector('.accordion__header')
        accordionHeader.addEventListener('click', event => {
          accordions.forEach(accordion => {
            accordion.classList.remove('open')
          })
          accordion.classList.toggle('open')
        })
      })
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-accordion"] && !window.DesignMode) return;
  try {
    
      const accordions = Array.from(document.querySelectorAll('.accordion'))
      accordions.forEach(accordion => {
        const accordionHeader = accordion.querySelector('.accordion__header')
        accordionHeader.addEventListener('click', event => {
          accordions.forEach(accordion => {
            accordion.classList.remove('open')
          })
          accordion.classList.toggle('open')
        })
      })
      
  } catch(e) { console.error(e); }
})();
})();
